import { ReactNode } from "react";
import { ErrorBoundary } from "@sentry/react";
import { getRedactedOrNodeOrFallback } from "../lib/i18n-helpers";
import en from "./_i18n/en.json";
import jp from "./_i18n/jp.json";
import pt from "./_i18n/pt.json";
import es from "./_i18n/es.json";

const recoveryTranslations = { en, jp, pt, es };

function HubErrorFallback() {
  // This boundary sits above I18nProvider. Bundle the recovery copy so it also
  // works when providers or translation chunk loading caused the crash.
  let translations = en.components.hubErrorBoundary;
  try {
    const language = window.localStorage.getItem("admin.i18n.lang");
    if (language && Object.prototype.hasOwnProperty.call(recoveryTranslations, language)) {
      translations = recoveryTranslations[language as keyof typeof recoveryTranslations].components.hubErrorBoundary;
    }
  } catch {
    // Storage can be unavailable; keep recovery usable in English.
  }
  const t = (key: keyof typeof translations) =>
    getRedactedOrNodeOrFallback(translations, key, en.components.hubErrorBoundary[key]);

  return (
    <main role="alert">
      <h1>{t("title")}</h1>
      <p>{t("message")}</p>
      <button type="button" onClick={() => window.location.reload()}>
        {t("reload")}
      </button>
    </main>
  );
}

export default function HubErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary
      fallback={<HubErrorFallback />}
    >
      {children}
    </ErrorBoundary>
  );
}
